export const numbersData = [
  {
    number: "110+",
    name: "Cities",
    description:
      " Skyscrapers, Roads, and Infrastructure that Define Modern Cities nationwide in Pakistan",
  },
  {
    number: "200+",
    name: "Clients",
    description:
      "Our Satisfied Clients,Testimonials Speak of Quality Buildings, Roads and Trusted Partnerships",
  },
  {
    number: "110+",
    name: "Projects",
    description:
      "Our Satisfied Clients,Testimonials Speak of Quality Buildings,Roads and Trusted Partnerships",
  },
];
